import styled from 'styled-components';

const FormContainer = styled.article`
	${props => props.theme.breakpoints.up('xs')} {
		padding: 0px 0px 15% 0px;
		background: transparent;
	}
	${props => props.theme.breakpoints.up('sm')} {
		background: #171717;
		box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
		padding: 6% 10%;
	}
`;

export default FormContainer;
